import React from 'react' // eslint-disable-line no-unused-vars
import { Route } from 'react-router'
import { triggerSSO } from './mi-app/InitiateSSO'
import { getJwt } from './pages/functions'
import jwt from 'jsonwebtoken'
import { config } from './json/config'

class AccessedRoute extends React.Component {
  constructor (props) {
    super(props)
    this.permissions = []
  }

  componentWillMount () {
    const token = getJwt()
    if (token === '') {
      this.props.path === '/scibooth'
        ? triggerSSO('en', 'scibooth')
        : triggerSSO('en')
    }
    const pubkey = config[window.location.hostname].pubkey
    try {
      const decoded = jwt.verify(token, pubkey, { algorithms: ['RS256'] })
      this.permissions = decoded.permissions
    } catch (err) {
      this.props.path === '/scibooth'
        ? triggerSSO('en', 'scibooth')
        : triggerSSO('en')
    }
  }

  render () {
    const {
      component: Component,
      requiredPermission,
      renderFunction,
      ...rest
    } = this.props
    return (
      <Route
        {...rest}
        render={props =>
          this.permissions.includes(requiredPermission) ? (
            Component ? (
              <Component {...props} />
            ) : (
              renderFunction(props)
            )
          ) : null}
      />
    )
  }
}

export default AccessedRoute



// WEBPACK FOOTER //
// ./src/AccessedRoute.js